import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import filmAlimentaire from "@/assets/products/film-alimentaire.png";

const config: ProductPageConfig = {
  name: "Film alimentaire étirable",
  breadcrumbName: "Film étirable",
  subtitle: "Film alimentaire professionnel étirable pour conserver et protéger vos aliments",
  features: ["Contact alimentaire", "Étirable", "Professionnel", "Disponible en stock"],
  variants: [
    { name: "Film étirable 30cm x 300m", dimensions: "30 cm x 300 m", material: "Film alimentaire", packaging: "Carton de 6 rouleaux", palette: "336 cartons", image: filmAlimentaire },
  ],
};

const FilmEtirable = () => <ProductPageLayout config={config} />;
export default FilmEtirable;
